<p-orderList [value]="files" [dragdrop]="true" (onReorder)="onReorder()">
  <ng-template let-file pTemplate="item">
    <div class="file-row">
      <div class="position-circle">{{ file.position }}</div>
      <span class="title">{{ file.name }}</span>
    </div>
  </ng-template>
</p-orderList>
@if (isUpdating) {
  <div class="status"><i class="fa-regular fa-rotate"></i> Speichern ...</div>
}
